// extracted by mini-css-extract-plugin
module.exports = {"base":"BrandMark-base-3lhGI","md":"BrandMark-md-VFofQ","lg":"BrandMark-lg-12pZ-"};